import React, {useEffect, useState} from "react";
import {CONFIG} from "../../util/config";
import {Spin} from "antd";
import ppdImage from '../PPD-Purple-Endorser.png'
import LoginForm, {LoginState} from "../../components/login/login-form/LoginForm";
import {CopyrightNotice} from "../../components/common/CopyrightNotice";
import styling from "./LoginPage.module.scss"
import TermsConditionsDialog from "../../components/login/terms-and-conditions/TermsConditionsDialog";
import NoActiveLicenceDialog from "../../components/login/invalid-licence/NoActiveLicenceDialog";
import ChangePassword from "../../components/login/change-password/ChangePassword";
import {VantageTitle} from "@healthiq/vantage-ui-components";

const acceptTerms = () : Promise<boolean> => {
    return fetch(CONFIG.restPrefix + '/login/accept-terms-of-use', {
        method: 'POST',
        ...(CONFIG.isDev && { credentials: 'include' })
    })
        .then(response => response.status === 200)
        .catch(error => {
            return false;
        })
}

const LoginPage = ({setLoggedIn}: { setLoggedIn: (loggedIn: boolean) => void }) => {

    const [isLoadingData, setIsLoadingData] = useState(true)
    const [loginResponse, setLoginResponse] = useState<LoginState | null>(null);

    const checkLogin = () : Promise<void> => {
        return fetch(CONFIG.restPrefix + '/login/login-check', {
            method: 'POST',
            ...(CONFIG.isDev && { credentials: 'include' })
        })
            .then(response => {
                return response.json()
            })
            .then((loginStatus: {status: LoginState}) => {
                setLoginResponse(loginStatus.status)
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                setIsLoadingData(false);
            })
    }

    useEffect(() => {
        checkLogin()
    }, [])

    useEffect(() => {
        if (loginResponse && loginResponse === "SUCCESS") {

            setLoggedIn(true);
            const params = new URLSearchParams(window.location.search);
            const redirect = params.get("redirect");

            if (redirect) {
                window.location.href = redirect;
                return;
            }
        }
    }, [loginResponse, setLoggedIn]);

    if (isLoadingData) {
        return <div>
            <p>Loading user data...</p>
            <Spin/>
        </div>
    }

    const onAcceptTerms = () => {
        acceptTerms()
            .then(checkLogin)
    }

    const onPasswordChange = () => {
        checkLogin()
            .finally(() => setLoginResponse(null))
    }


    return <div className={styling.loginWrapper}>
        {/* centre block */}
        <h1 style={{ margin: "24px 16px 16px 16px" }}><VantageTitle /></h1>
        <div className={styling.loginBox}>

            <div className={styling.leftBox}>
                <p className={styling.welcome}>Welcome</p>
                <p className={styling.top}>The leading online analytics platform for real-world data</p>
                <p className={styling.lower}>A powerful, flexible suite with robust credible data that you and your team can interrogate, spot trends and also use to engage externally with healthcare professionals</p>
            </div>
            
            <div className={styling.rightBox}>
                <p className={styling.title}>
                    SIGN IN
                </p>
                <LoginForm onLoginChange={setLoginResponse} />
            </div>

        </div>
        <CopyrightNotice style={{ width: "auto", padding: "0px", margin: "16px"}}/>
        <div style={{display: "flex"}}>
            <img alt={"ppd by Thermo Fisher Scientific"} style={{ width: "200px"}} src={ppdImage}/>
        </div>
        {<NoActiveLicenceDialog open={loginResponse === "NO_LICENSE"} /> }
        {<TermsConditionsDialog open={loginResponse === "TOC_ACCEPT"} onOk={onAcceptTerms} />}
        {<ChangePassword open={loginResponse === "PASSWORD_RESET_REQUIRED"} onSuccess={() => onPasswordChange()}/>}
    </div>
}

export default LoginPage;